import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CONTROL } from '../../../../components';
import { generateCpuItems, generateRamItems, getObs } from '../../../utils';
var RedisVersionItem = {
  Redis3: '3',
  Redis4: '4',
  Redis5: '5',
  Redis6: '6'
};
var versionItems = [{
  value: RedisVersionItem.Redis3,
  label: 'Redis 3.0'
}, {
  value: RedisVersionItem.Redis4,
  label: 'Redis 4.0'
}, {
  value: RedisVersionItem.Redis5,
  label: 'Redis 5.0'
}, {
  value: RedisVersionItem.Redis6,
  label: 'Redis 6.0'
}];
var InstanceTypeItem = {
  MasterStandby: 'Master/Standby',
  SingleNode: 'Single-Node',
  ProxyCluster: 'Proxy Cluster',
  RedisCluster: 'Redis Cluster'
};
var instanceTypeItemMasterStandby = {
  value: InstanceTypeItem.MasterStandby,
  label: 'Master/Standby',
  description: 'Каждый экземпляр работает на двух узлах кэша - один главный (для чтения/записи данных) и один резервный (реплицирует данныев режиме реального времени и берет на себя управление в случае сбоя основного кэш-узла'
};
var instanceTypeItemSingleNode = {
  value: InstanceTypeItem.SingleNode,
  label: 'Single-Node',
  description: 'Каждый экземпляр работает только на одном узле кэша. В основном используются для временного хранения данных и не подходят для сценариев обслуживания с высокой надежностью, поддерживают интенсивные параллельные операции чтения/записи, но не обеспечивают сохранение данных'
};
var instanceTypeItemProxyCluster = {
  value: InstanceTypeItem.ProxyCluster,
  label: 'Proxy Cluster',
  description: 'Используется так же, как экземпляр с одним узлом. Приложения получают доступ к Redis через прокси'
};
var instanceTypeItemRedisCluster = {
  value: InstanceTypeItem.RedisCluster,
  label: 'Redis Cluster',
  description: 'Нативная распределенная реализация Redis. Приложения подключаются через клиентов Redis Cluster'
};
var versionToInstanceTypeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RedisVersionItem.Redis3, [instanceTypeItemMasterStandby, instanceTypeItemSingleNode, instanceTypeItemProxyCluster]), RedisVersionItem.Redis4, [instanceTypeItemMasterStandby, instanceTypeItemSingleNode, instanceTypeItemRedisCluster]), RedisVersionItem.Redis5, [instanceTypeItemMasterStandby, instanceTypeItemSingleNode, instanceTypeItemRedisCluster]), RedisVersionItem.Redis6, [instanceTypeItemMasterStandby, instanceTypeItemSingleNode]);
var versionInstanceTypeToCacheSizeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RedisVersionItem.Redis3, _defineProperty(_defineProperty(_defineProperty({}, InstanceTypeItem.MasterStandby, [2, 4, 8, 16, 32, 64]), InstanceTypeItem.SingleNode, [2, 4, 8, 16, 32, 64]), InstanceTypeItem.ProxyCluster, [64, 128, 256])), RedisVersionItem.Redis4, _defineProperty(_defineProperty(_defineProperty({}, InstanceTypeItem.MasterStandby, [1, 2, 4, 8, 16, 24, 32, 48, 64]), InstanceTypeItem.SingleNode, [1, 2, 4, 8, 16, 24, 32, 48, 64]), InstanceTypeItem.RedisCluster, [4, 8, 16, 32, 64, 128, 256])), RedisVersionItem.Redis5, _defineProperty(_defineProperty(_defineProperty({}, InstanceTypeItem.MasterStandby, [1, 2, 4, 8, 16, 24, 32, 48, 64]), InstanceTypeItem.SingleNode, [1, 2, 4, 8, 16, 24, 32, 48, 64]), InstanceTypeItem.RedisCluster, [4, 8, 16, 32, 64, 128, 256])), RedisVersionItem.Redis6, _defineProperty(_defineProperty({}, InstanceTypeItem.MasterStandby, [1, 2, 4, 8, 16, 24, 32, 48, 64]), InstanceTypeItem.SingleNode, [1, 2, 4, 8, 16, 24, 32, 48, 64]));
var versionInstanceTypeToReplicasCountMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RedisVersionItem.Redis3, _defineProperty(_defineProperty(_defineProperty({}, InstanceTypeItem.MasterStandby, []), InstanceTypeItem.SingleNode, []), InstanceTypeItem.ProxyCluster, [])), RedisVersionItem.Redis4, _defineProperty(_defineProperty(_defineProperty({}, InstanceTypeItem.MasterStandby, [2, 3, 4, 5]), InstanceTypeItem.SingleNode, []), InstanceTypeItem.RedisCluster, [1, 2, 3, 4, 5])), RedisVersionItem.Redis5, _defineProperty(_defineProperty(_defineProperty({}, InstanceTypeItem.MasterStandby, [2, 3, 4, 5]), InstanceTypeItem.SingleNode, []), InstanceTypeItem.RedisCluster, [1, 2, 3, 4, 5])), RedisVersionItem.Redis6, _defineProperty(_defineProperty({}, InstanceTypeItem.MasterStandby, [2]), InstanceTypeItem.SingleNode, []));
var cacheSizeItems = generateRamItems([2, 4, 8, 16, 32, 64]);
export var DCS_REDIS_FORM_CONFIG = {
  ui: [['version'], 'instanceType', ['cacheSize', 'instancesCount'], 'obsAlert', ['replicasCount'], ['obs']],
  controls: {
    version: {
      type: CONTROL.SelectSingle,
      accessorKey: 'version',
      defaultValue: RedisVersionItem.Redis3,
      items: versionItems,
      decoratorProps: {
        label: 'Версия',
        labelTooltip: "\u042D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440\u044B Redis \u0432\u0435\u0440\u0441\u0438\u0438 3.0 \u0440\u0430\u0437\u0432\u043E\u0440\u0430\u0447\u0438\u0432\u0430\u044E\u0442\u0441\u044F \u043D\u0430 \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u043C\u0430\u0448\u0438\u043D\u0430\u0445 \u0437\u0430 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043C\u0438\u043D\u0443\u0442, \u0430 \u0432\u0435\u0440\u0441\u0438\u0438 4.0, 5.0 \u0438 6.0 \u2014 \u0432 \u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u0430\u0445 \u0437\u0430 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434."
      }
    },
    instanceType: {
      type: CONTROL.Carousel,
      accessorKey: 'instanceType',
      items: _toConsumableArray(versionToInstanceTypeMap[RedisVersionItem.Redis3]),
      defaultValue: InstanceTypeItem.MasterStandby,
      decoratorProps: {
        label: 'Тип инстанса'
      },
      watchedControls: {
        version: 'version'
      },
      relateFn: function relateFn(_ref) {
        var version = _ref.version;
        return {
          items: versionToInstanceTypeMap[version]
        };
      }
    },
    cacheSize: {
      type: CONTROL.Segmented,
      accessorKey: 'cacheSize',
      defaultValue: cacheSizeItems[0].value,
      items: cacheSizeItems,
      decoratorProps: {
        label: 'Объем кэша',
        labelTooltip: 'Брокер — это приложение, которое преобразует сообщения и выступает посредником между другими приложениями'
      },
      watchedControls: {
        version: 'version',
        instanceType: 'instanceType'
      },
      relateFn: function relateFn(_ref2) {
        var version = _ref2.version,
          instanceType = _ref2.instanceType;
        var items = versionInstanceTypeToCacheSizeMap[version][instanceType] || [];
        return {
          items: generateRamItems(items)
        };
      }
    },
    instancesCount: {
      type: CONTROL.Stepper,
      decoratorProps: {
        label: 'Количество инстансов'
      },
      accessorKey: 'instancesCount',
      defaultValue: 1,
      uiProps: {
        min: 1,
        max: 100,
        postfix: 'Шт'
      }
    },
    obsAlert: {
      type: CONTROL.Alert,
      uiProps: {
        description: 'Хранилище используется под бэкапы. Рекомендуем указывать объем не меньше объема кэша'
      },
      accessorKey: 'backup'
    },
    replicasCount: {
      type: CONTROL.Segmented,
      accessorKey: 'replicasCount',
      defaultValue: '1',
      items: generateCpuItems([1, 2, 3, 4, 5]),
      decoratorProps: {
        label: 'Количество реплик'
      },
      watchedControls: {
        version: 'version',
        instanceType: 'instanceType'
      },
      relateFn: function relateFn(_ref3) {
        var _versionInstanceTypeT3;
        var version = _ref3.version,
          instanceType = _ref3.instanceType;
        var items = versionInstanceTypeToReplicasCountMap === null || versionInstanceTypeToReplicasCountMap === void 0 ? void 0 : (_versionInstanceTypeT3 = versionInstanceTypeToReplicasCountMap[version]) === null || _versionInstanceTypeT3 === void 0 ? void 0 : _versionInstanceTypeT3[instanceType];
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
          return {
            items: generateCpuItems(items),
            uiProps: {
              visible: true
            }
          };
        }
        return {
          uiProps: {
            visible: false
          }
        };
      }
    },
    obs: getObs({
      space: {
        accessorKey: 'obs.space',
        defaultValue: 0,
        uiProps: {
          min: 0,
          max: 9999999900
        }
      },
      units: {
        accessorKey: 'obs.unitsOfCalculation'
      }
    })
  }
};